import { render, staticRenderFns } from "./AddToCart.vue?vue&type=template&id=e4a1bb7e"
import script from "./AddToCart.vue?vue&type=script&lang=js"
export * from "./AddToCart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/b2bprionecokr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e4a1bb7e')) {
      api.createRecord('e4a1bb7e', component.options)
    } else {
      api.reload('e4a1bb7e', component.options)
    }
    module.hot.accept("./AddToCart.vue?vue&type=template&id=e4a1bb7e", function () {
      api.rerender('e4a1bb7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/product/AddToCart.vue"
export default component.exports